import PrimaryButton from "@/Components/UI/Forms/PrimaryButton";
import Modal, { ModalProps } from "@/Components/UI/Modal";
import { Client } from "@/types/page";

type EmptyBoardActionItemsModalProps = Omit<ModalProps, "children"> & {
    client: Client;
};

export default function EmptyBoardActionItemsModal({
    client,
    ...props
}: EmptyBoardActionItemsModalProps) {
    const handleOpenGoalsBoard = () => {
        window.open(
            route("board.get", {
                otherUserId: client.id,
            }),
            "_blank",
        );
        props.onClose();
    };

    return (
        <Modal {...props} maxWidth="xl">
            <div className="flex h-full max-h-[80vh] flex-col items-stretch p-6 sm:p-8">
                <div className="pb-2 text-left text-2xl font-bold">
                    Goals board not updated
                </div>
                <div className="grow overflow-y-auto">
                    <p className="text-brand-gray">
                        The goals board hasn't been edited. Please update goals
                        and action steps before sharing with {client.first_name}
                        .
                    </p>
                </div>
                <div className="pt-6 text-center">
                    <PrimaryButton onClick={handleOpenGoalsBoard}>
                        Open Goals Board
                    </PrimaryButton>
                </div>
            </div>
        </Modal>
    );
}
